import Vue from 'vue';
import '@/common/logDiff'; // logger的加载要在最前
import '@/locales/importFirst';
import '@/common/reporter';
import pkg from 'package.json';
import { RecycleScroller } from 'vue-virtual-scroller';
import Aegis from '@tencent/aegis-web-sdk';
import VueCompositionAPI, { onMounted } from '@vue/composition-api';
import tdesign from 'tdesign-vue';
import Swiper2, { Autoplay, Pagination } from 'swiper'; // 6.x版本需要这样引用才能使用

import RavenVue from '@/renderer/scripts/libs/raven-js/plugins/vue';
import Raven from '@/renderer/scripts/libs/raven-js/src';
import { SENTRY_URL } from '@/common/constant';
import * as platform from '@/common/constant/platform';
import '@/renderer/directives/index';
import '@/renderer/components/index';
import '@/renderer/filters/index';
import '@/renderer/scripts/utils/desktop';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import 'tdesign-vue/es/style/index.css';
import '@/renderer/assets/global.scss';
import i18n, { i18n_t } from '@/locales/i18n';

import App from './App.vue';
import store from './store';
import router from './router';
Vue.component('RecycleScroller', RecycleScroller);
Swiper2.use([Autoplay, Pagination]); // 这行代码很关键

let project = platform.IS_BROWSER ? 'tcedrive-browser' : 'tcedrive-pc';
if (platform.IS_TEST) {
  project += '_test';
}

// 开启aegis监控 TAM开发者平台可查看性能数据 https://tam.woa.com/
let aegisId = platform.IS_BROWSER ? 'JmMBFQpPRNGnyKELPG' : 'JmMBFQpPhJvPotPXmr'; // 上报 id
// 正式环境
if (platform.IS_PUBLISH) {
  aegisId = platform.IS_BROWSER ? 'JmMBFQpPUJKtalkCBd' : 'JmMBFQpPmJmJsxhFhS'; // 上报 id
}

let aegis: Aegis;
if (!platform.IS_PRIVATE && !platform.IS_DEV) {
  aegis = new Aegis({
    // uin: 'xxx', // 用户唯一 ID（可选）
    id: aegisId,
    // 接口测速
    reportApiSpeed: true,
    // 静态资源测速
    reportAssetSpeed: true,
    spa: true, // spa 应用页面跳转的时候开启 pv 计算
  });
}

Vue.config.errorHandler = (err, vm, info) => {
  aegis && aegis.error(`Error: ${err.toString()}\nStack: ${err.stack}\nInfo: ${info}`);
  if (platform.IS_DEV) {
    console.error(`[Error] 通过vue errorHandler捕获的错误: err: ${err.toString()}, info: ${info}`);
    return;
  }
  try {
    logger.ui.error(`[Error] 通过vue errorHandler捕获的错误: err: ${err.toString()}, info: ${info}`);
  } catch (error) {
    logger.ui.error(`[Error] 通过vue errorHandler捕获的错误: err: ${err}, info: ${info}`);
  }
};
if (platform.IS_BROWSER) {
  !platform.IS_DEV &&
    !platform.IS_PRIVATE &&
    Raven.config(SENTRY_URL, {
      release: `${project}-${pkg.version}`,
      environment: platform.platform,
    })
      .addPlugin(RavenVue, Vue)
      .install();
} else if (!platform.IS_DEV && !platform.IS_PRIVATE) {
  const { init } = window.require('@sentry/electron');
  const { Vue: VueIntegration } = window.require('@sentry/integrations');
  init({
    dsn: SENTRY_URL,
    release: `${project}-${pkg.version}`,
    environment: platform.platform,
    integrations: [
      new VueIntegration({
        Vue,
        attachProps: true,
        logErrors: true,
      }),
    ],
    enableNative: false, // 解决windows上报crashReporter.start问题
  });
}

Vue.use(VueCompositionAPI);
Vue.use(tdesign);
Vue.config.productionTip = false;
window.onerror = (message, source, lineno, colno, error) => {
  if (platform.IS_DEV) {
    console.error(
      `[Error] 捕获到的JS异常: message: ${message}, source: ${source}, lineno: ${lineno}, colno: ${colno}, error: ${error?.toString()}`,
    );
    return;
  }

  try {
    logger.worker.error(
      `[Error] 捕获到的JS异常: message: ${message}, source: ${source}, lineno: ${lineno}, colno: ${colno}, error: ${error?.toString()}`,
    );
  } catch (error) {
    logger.worker.error(
      `[Error] 捕获到的JS异常: message: ${message}, source: ${source}, lineno: ${lineno}, colno: ${colno}, error: ${error}`,
    );
  }
};
window.addEventListener(
  'error',
  e => {
    const target = e.target || e.srcElement;
    const isElementTarget =
      target instanceof HTMLScriptElement || target instanceof HTMLLinkElement || target instanceof HTMLImageElement;
    if (isElementTarget) {
      // @ts-ignore
      const url = target.src || target.href;
      // @ts-ignore
      const outerHTML = target?.outerHTML;
      /* i18n-ignore*/
      logger.ui.error(`捕获到的资源加载异常, url: ${url}, outerHTML: ${outerHTML}`);
    }
  },
  true,
);
!platform.IS_DEV &&
  window.addEventListener('unhandledrejection', e => {
    e.preventDefault();
    /* i18n-ignore*/
    logger.ui.error('捕获到promise错误:');
    /* i18n-ignore*/
    logger.ui.error('错误原因:%s', JSON.stringify(e, ['message', 'arguments', 'type', 'name', 'reason']));
    return true;
  });
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
